import styled from "@emotion/styled";

export const Card = styled.section`
  display: grid;
  gap: ${({ theme }) => theme.space.space24};
  padding: ${({ theme }) => theme.space.space24};
  border-radius: ${({ theme }) => theme.effects.rounding._4};
  background-color: ${({ theme }) => theme.colors.tone.sand};
`;
